'use strict';

// Frontend builds import shared DTOs that use GraphQL decorators.
// This shim keeps those decorators inert in browser/SSR bundles.

Object.defineProperty(exports, '__esModule', { value: true });

const dummyValue = '';

function dummyFn() {
  return;
}

function dummyDecorator() {
  return dummyFn;
}

exports.dummyValue = dummyValue;
exports.dummyFn = dummyFn;
exports.dummyDecorator = dummyDecorator;

exports.Arg = dummyDecorator;
exports.Args = dummyDecorator;
exports.ArgsType = dummyDecorator;
exports.Authorized = dummyDecorator;
exports.Ctx = dummyDecorator;
exports.Directive = dummyDecorator;
exports.Extensions = dummyDecorator;
exports.Field = dummyDecorator;
exports.FieldResolver = dummyDecorator;
exports.HideField = dummyDecorator;
exports.Info = dummyDecorator;
exports.InputType = dummyDecorator;
exports.InterfaceType = dummyDecorator;
exports.Mutation = dummyDecorator;
exports.ObjectType = dummyDecorator;
exports.PubSub = dummyDecorator;
exports.Query = dummyDecorator;
exports.Resolver = dummyDecorator;
exports.Root = dummyDecorator;
exports.Scalar = dummyDecorator;
exports.Subscription = dummyDecorator;
exports.UseMiddleware = dummyDecorator;

exports.createUnionType = dummyFn;
exports.registerEnumType = dummyFn;

exports.Float = dummyValue;
exports.GraphQLISODateTime = dummyValue;
exports.GraphQLTimestamp = dummyValue;
exports.ID = dummyValue;
exports.Int = dummyValue;
